import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "styles/colors";
import classnames from "classnames";
import { StyledBackgroundTriangleComponent } from "./background-triangle-component.scss";
class BackgroundTriangleComponent extends PureComponent {
    getInlineStyles(borderColor, gradientColor) {
        let styles = {};
        if (borderColor) {
            styles.borderBottomColor = colors[borderColor];
        }
        if (gradientColor) {
            const bgColor = colors[gradientColor];
            const whiteColor = colors["white"];
            styles.background = `linear-gradient(172deg, ${bgColor} 0%, ${bgColor} calc(100vh / 1.3), ${whiteColor} calc(100vh / 1.29), ${whiteColor})`;
        }
        return styles;
    }
    render() {
        const { borderColor, gradientColor, straightBorder } = this.props;
        return /*#__PURE__*/ _jsx(StyledBackgroundTriangleComponent, {
            className: classnames("background-triangle", {
                "straight-border": straightBorder
            }),
            style: this.getInlineStyles(borderColor, gradientColor)
        });
    }
}
export { BackgroundTriangleComponent as default };
BackgroundTriangleComponent.defaultProps = {
    straightBorder: false
};
